import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, Button } from '@material-ui/core';

const ratingLabels = {
  1: 'Significantly Below Expectations',
  2: 'Needs Improvement',
  3: 'Meets Expectations',
  4: 'Exceeds Expectations',
  5: 'Significantly Exceeds Expectations',
};

const getColor = (val) => {
  if (val <= 1) return { bg: '#ff0000', text: '#ff0000' };
  if (val <= 2) return { bg: '#ff7f50', text: '#ff7f50' };
  if (val <= 3) return { bg: '#ffa500', text: '#ffa500' };
  if (val <= 4) return { bg: '#90ee90', text: '#90ee90' };
  return { bg: '#008000', text: '#008000' };
};

const useStyles = makeStyles((theme) => ({
  root: {
    border: '1px solid rgba(0,0,0,0.12)',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2),
    backgroundColor: '#fafafa',
  },
  label: {
    fontWeight: 600,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(1),
    textTransform: 'uppercase',
  },
  ratingRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    flexWrap: 'wrap',
  },
  ratingLabel: {
    fontSize: '0.625rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(0.5),
  },
  circle: {
    minWidth: 36,
    width: 36,
    height: 36,
    borderRadius: '50%',
    padding: 0,
    fontWeight: 700,
    fontSize: '0.875rem',
  },
  ratingDescription: {
    fontSize: '0.75rem',
    fontWeight: 500,
    marginLeft: theme.spacing(0.5),
  },
}));

const ScoreSlider = ({ label, value, onChange, maxScore = 5, disabled = false }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      {label && <Typography className={classes.label}>{label}</Typography>}
      <Box className={classes.ratingRow}>
        <Typography className={classes.ratingLabel}>Rating</Typography>
        {Array.from({ length: maxScore }, (_, i) => i + 1).map((num) => {
          const selectedColors = value > 0 ? getColor(value) : null;
          const isFilled = value > 0 && num <= value;
          return (
            <Button
              key={num}
              className={classes.circle}
              onClick={() => onChange(num)}
              disabled={disabled}
              variant={isFilled ? 'contained' : 'outlined'}
              style={
                isFilled
                  ? { backgroundColor: selectedColors.bg, color: '#fff', borderColor: selectedColors.bg }
                  : { backgroundColor: '#d3d3d3', color: '#555', borderColor: '#d3d3d3' }
              }
              size="small"
            >
              {num}
            </Button>
          );
        })}
        {value > 0 && (
          <Typography
            className={classes.ratingDescription}
            style={{ color: getColor(value).text }}
          >
            {ratingLabels[value]}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default ScoreSlider;
